import { render, staticRenderFns } from "./DescPopup.vue?vue&type=template&id=0615f37c&scoped=true"
import script from "./DescPopup.vue?vue&type=script&lang=js"
export * from "./DescPopup.vue?vue&type=script&lang=js"
import style0 from "./DescPopup.vue?vue&type=style&index=0&id=0615f37c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0615f37c",
  null
  
)

export default component.exports